import { ComponentPropsWithoutRef, FC, ReactNode, Ref } from 'react';
import classNames from 'classnames';

import styles from './ModalBody.module.css';

export type ModalBodyProps = {
  children?: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
} & Omit<ComponentPropsWithoutRef<'div'>, 'className'>;

/** Тело модалки со скроллом. */
const ModalBody: FC<ModalBodyProps> = ({ children, className, ref, ...rest }) => (
  <div
    ref={ref}
    {...rest}
    className={classNames(styles.body, className)}>
    {children}
  </div>
);

export default ModalBody;
